kv.controller('internalObjectEditCtrl', function ($uibModalInstance, data, $injector, $scope) {
	return new dictionaryEditCtrl($uibModalInstance, data, $injector, $scope, {
		entity: "internal_object",
		primaryKey: "internal_object_id",
		newEntity:{
		},
		prepareDataToSave: function () {
			let dataToSend = angular.copy(this.data);
			return dataToSend;
		}
	});
});